import { cycloneApiClient } from '@/shared/api/core/axios-instance';

import { delayDagMockMutation } from '@/entities/dag/api/_internal/dagMockDelay';
import { triggerDagInMockStore } from '@/entities/dag/api/_internal/dagMockStore';
import { shouldUseDagMockApi } from '@/entities/dag/api/_internal/shouldUseDagMockApi';
import type { TriggerDagRequest, TriggerDagResponse } from '@/entities/dag/domain/types';

export const triggerDagApi = async ({
  dagUuid,
  version,
  deployed,
  code,
}: TriggerDagRequest): Promise<TriggerDagResponse> => {
  if (shouldUseDagMockApi()) {
    await delayDagMockMutation('standard');
    return triggerDagInMockStore({
      dagUuid,
      version,
      deployed,
      code,
    });
  }

  let payload: { deployed: true } | { version: number } | { code: string };

  if (deployed === true) {
    payload = { deployed: true };
  } else if (typeof version === 'number' && Number.isFinite(version)) {
    payload = { version };
  } else {
    payload = {
      code: code ?? '',
    };
  }

  const response = await cycloneApiClient.post<TriggerDagResponse>(`/dags/${dagUuid}/trigger`, payload);
  return response.data;
};
